import React from 'react';
import { DSCircularProgressIndicator } from '@elliemae/ds-basic/CircularProgressIndicator';
import styled from 'styled-components';

var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-18oj125-0"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:100%;"]);

var LoadingIndicator = function LoadingIndicator() {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "shuttle__loading-indicator"
  }, /*#__PURE__*/React.createElement(DSCircularProgressIndicator, {
    size: "xl",
    showLabel: true
  }));
};

export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map
